// client/src/components/InputDynamicText.js
import React, {useState} from "react";
import * as Constants from '../constants'
import { useStyles } from "../hooks/useStyles";
import Checkbox from '../components/Checkbox';
import { useTranslation } from "react-i18next";
  
export const InputDynamicText = ({
  initialText = '',
  rows = 8,
  cols = 16,
  handleTextClick = function() {},
  checkboxPosition = 'below',  // 'below' | 'side'
  placeholder = 'default',
}) => {
  const [text, setText] = useState(initialText);
  const [showMoreSpace, setShowMoreSpace] = useState(false);
  const [inputButtonIsPink, setInputButtonIsPink] = useState(false);

  const { t } = useTranslation();
  const { editBoxStyle,
          } = useStyles();

  const isCheckboxOnSide =  checkboxPosition === 'side';
  const realPlaceholder =
    placeholder === 'default'
      ? t('ordersList.range_note_col.placeholderDefault')
      : placeholder;

  return (
    <div
      style={
        isCheckboxOnSide
          ? { width: 'fit-content', display: 'flex', flexDirection: 'row',
              alignItems: 'center', gap: '4px',
            }
          : { width: 'fit-content' }
      }
    >
      <label className="container-hug-bottom">
        {showMoreSpace
          ? // Large space for detailed editing
            <textarea
              value={text}
              placeholder={realPlaceholder}
              onChange={(e) => {
                setText(e.target.value);
                setInputButtonIsPink(true);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  setInputButtonIsPink(false);
                  handleTextClick(text)
                }
              }}
              rows={rows}
              cols={cols}
              maxLength={Constants.RANGE_NOTE_MAX_CHARS}
              style={ editBoxStyle({
                width: '',
                margin: '2px',
                resize: 'both',
                changeColorOfBox: inputButtonIsPink,
                editBoxColor: Constants.O_BOX_PINK,
              }) }
            />
          : // Short, single-line space
            <input
              type="text"
              value={text}
              placeholder={realPlaceholder}
              maxLength={Constants.RANGE_NOTE_MAX_CHARS}
              onChange={(e) => {
                setText(e.target.value);
                setInputButtonIsPink(true);
              }}
              onKeyUp={e => {
                if (e.key === 'Enter') {
                  setInputButtonIsPink(false);
                  handleTextClick(text)
                }
              }}
              style={ editBoxStyle({
                width: "30px",
                margin: showMoreSpace ? "" : "0px",
                padding: showMoreSpace ? "" : "1px",
                changeColorOfBox: inputButtonIsPink,
                editBoxColor: Constants.O_BOX_PINK,
              }) }
            />
        }
      </label>

      <Checkbox
        size         = 'h6'
        isChecked    = {showMoreSpace} 
        setIsChecked = {setShowMoreSpace}
        tippyAlert   = {t('checkbox.inputDynamicText.tippyContent', {
          rangeNoteMaxChars: Constants.RANGE_NOTE_MAX_CHARS,
        })}
        // Click the checkbox to expand the typing area....
      />
    </div>
  );
};

export default InputDynamicText;

